import { Observable, BehaviorSubject } from 'rxjs';
import { Device, DevicesSettingsService } from './devices-settings.service';
import { Component, OnInit } from '@angular/core';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-devices-settings',
  templateUrl: './devices-settings.component.html',
  styleUrls: ['./devices-settings.component.scss'],
  providers: [DevicesSettingsService],
})
export class DevicesSettingsComponent implements OnInit {
  deviceSub = new BehaviorSubject(0);
  devices: Observable<Device[]> = this.deviceSub
    .asObservable()
    .pipe(switchMap(() => this.devicesSettingsService.getDevices()));
  tableColumns: string[] = ['idHex', 'idDec', 'delete'];
  loading = true;
  newDeviceID: string = '';
  constructor(private devicesSettingsService: DevicesSettingsService) {}

  ngOnInit() {}

  addDevice() {
    this.devicesSettingsService
      .addDevice(parseInt(this.newDeviceID, 16))
      .subscribe({
        next: () => {
          this.deviceSub.next(0);
        },
        complete: () => {
          this.newDeviceID = '';
        },
      });
  }

  deleteDevice(deviceId: number) {
    this.devicesSettingsService.deleteDevice(deviceId).subscribe();
  }
}
